import React from 'react';

const LightningIcon: React.FC = () => {
	return (
		<svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
			<path d="M1.14062 8.90843L5.6419 0H12.7153L9.14939 5.15751H15.0537L4.12199 16L5.99265 8.90843H1.14062Z" fill="#FFAF32"/>
		</svg>
	)
}

export default LightningIcon;
